import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/regiments",
        component: List,
        name: "regiments-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/regiments/:id/edit",
        component: Edit,
        name: "regiments-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/regiments/create",
        component: Create,
        name: "regiments-create",
        meta: {
            requiresAuth: true,
        },
    },
];
